import styled from 'styled-components';
import { BLACK_COLOR, DEFAULT_FONT, WHITE_COLOR } from '../../styles/variables';

export const Filters = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  align-items: flex-end;
  .searchDoc {
    display: flex;
    justify-content: flex-end;
    column-gap: 16px;
    .ant-input-suffix {
      top: 80%;
    }
  }
  .tagFilter {
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: space-around;
    border: 1px solid #d9d9d9;
    width: 110px;
    padding: 0 10px;
    height: 32px;
    border-radius: 5px;
    font-weight: 600;
    cursor: pointer;
    position: relative;
    column-gap: 4px;
    p {
      font-size: 0.7rem;
      color: rgb(143 141 141);
      font-weight: 600;
      letter-spacing: 0.5px;
    }
    .tagsCount {
      background: #919191;
      border-radius: 50%;
      position: absolute;
      right: -10%;
      bottom: 58%;
      height: 20px;
      width: 20px;
      color: ${WHITE_COLOR} !important;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 10px !important;
    }
    .anticon {
      font-size: 15px;
    }
    .ant-select {
      position: absolute;
      top: 105%;
      right: 0%;
      width: 475px !important;
      z-index: 1000 !important;
    }

    .ant-select-selection--multiple {
      max-height: 104px !important;
      overflow-y: scroll !important;
      border-radius: 16px;
      font-size: 0.8rem !important;
      font-weight: 500 !important;
    }
    .ant-select-selection--multiple .ant-select-selection__rendered > ul > li {
      height: 30px;
      line-height: 30px !important;
    }
    .ant-select-selection__choice {
      font-size: 0.7rem !important;
      background: #ffdd80;
      border: 0;
      height: 32px;
      border-radius: 15px;
      line-height: unset !important;
    }
    .anticon-close.ant-select-remove-icon {
      font-size: 10px !important;
    }
  }
  .ant-input-search.ant-input-affix-wrapper {
    height: 30%;
    width: 350px !important;
  }
  .ant-input-affix-wrapper .ant-input-suffix {
    transform: none;
  }
  .ant-input-affix-wrapper .ant-input {
    font-size: 12px;
    font-family: ${DEFAULT_FONT} !important;
    border-radius: 18px;
  }
  .anticon svg {
    color: ${BLACK_COLOR};
  }
  .ant-select-selection--single .ant-select-selection__rendered {
    color: ${BLACK_COLOR};
  }

  .ant-radio-button-wrapper {
    font-size: 12px;
    line-height: 26px;
  }
  .ant-radio-button-wrapper:first-child {
    border-radius: 12px 0 0 12px;
  }
  .ant-radio-button-wrapper:last-child {
    border-radius: 0 12px 12px 0;
  }
  .ant-checkbox + span {
    font-size: 12px !important;
    text-transform: uppercase;
    font-weight: 500;
    letter-spacing: 0.25px;
  }
  .selectAll {
    display: flex;
    align-items: center;
    p {
      font-size: 12px !important;
      text-transform: uppercase;
      font-weight: 500;
      letter-spacing: 0.25px;
      padding-left: 8px;
      padding-right: 8px;
      line-height: 2.2 !important;
    }
  }
`;

export const DateRangeFilter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 12px;
  padding: 5px;
  background-color: #fbfbfb;
  border-radius: 12px;
  .ant-select {
    font-size: 10px;
    margin-left: 12px;
    @media only screen and (min-width: 1640px) {
      font-size: 14px;
    }
  }
  .ant-select-selection--single {
    border-radius: 30px;
    background: #f1f0f6;
    @media only screen and (min-width: 1640px) {
      height: 36px;
      padding: 2px 0;
    }
  }
  .ant-select-selection--multiple .ant-select-selection__rendered {
    font-family: ${DEFAULT_FONT} !important;
  }

  .ant-input {
    cursor: pointer;
    border-radius: 30px;
    background-color: ${WHITE_COLOR};
    @media only screen and (min-width: 1640px) {
      height: 36px;
    }
  }
  .ant-select-selection--single .ant-select-selection__rendered {
    color: ${BLACK_COLOR};
  }
  .dateTimePicker {
    width: 220px;
    label {
      font-size: 0.7rem;
    }
    input[type='text'] {
      font-size: 0.7rem;
      font-family: ${DEFAULT_FONT} !important;
      cursor: pointer;
    }
  }
`;

export const PageFilter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 12px;
  .page-filter-title {
    display: flex;
    flex-direction: column;
    row-gap: 6px;
    p {
      font-size: 12px;
    }
    .ant-input-number-input {
      font-family: inherit !important;
      font-size: 14px;
      font-weight: 600;
    }
  }
`;